// Counter-scales the app for OS display scaling and browser zoom, replacing the
// fixed per-DPI zoom tiers that used to live in dpi.css. The value is exposed as
// the `--app-zoom` CSS variable, which dpi.css applies to .container/.modal.
const MIN_ZOOM = 50;
const MAX_ZOOM = 100;

export const applyAppZoom = () => {
  const dpr = window.devicePixelRatio || 1;
  const zoom = Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, (1 / dpr) * 100));

  document.documentElement.style.setProperty('--app-zoom', `${zoom}%`);
};

export const initAppZoom = () => {
  applyAppZoom();
  // Browser zoom changes devicePixelRatio and fires `resize`
  window.addEventListener('resize', applyAppZoom);
};

// Effective CSS zoom applied to `node` by its zoomed ancestors (1 when unzoomed).
export const getEffectiveZoom = (node) => {
  if (!node || !node.offsetWidth) return 1;
  return node.getBoundingClientRect().width / node.offsetWidth || 1;
};

// dnd-kit measures in screen pixels, but a transform inside a CSS-zoomed element is
// scaled by that zoom again. Returns a translate that keeps `node` under the cursor.
export const getZoomSafeTranslate = (node, transform, { lockX = false } = {}) => {
  if (!transform) return undefined;
  const zoom = getEffectiveZoom(node);
  const x = lockX ? 0 : transform.x / zoom;
  return `translate3d(${x}px, ${transform.y / zoom}px, 0)`;
};
